import { Box, VisuallyHidden, Text, Flex, Separator, IconButton } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FcFeedback, FcInfo, FcInspection } from "react-icons/fc";
import CountryFlag from "./CountryFlag";
import { useColorModeValue } from "@/components/ui/color-mode";
import { Tooltip } from "@/components/ui/tooltip"
import { useNavigate } from "react-router-dom";
import { useI18n } from "src/i18n/I18nContext";

const SocialButton = ({
    children,
    label,
    href,
}: {
    children: ReactNode;
    label: string;
    href: string;
}) => {
    const navigate = useNavigate();
    return (
        <Tooltip content={label}>
            <IconButton
                bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
                rounded={'full'}
                cursor={'pointer'}
                onClick={() => navigate(href)}
                alignItems={'center'}
                justifyContent={'center'}
                transition={'background 0.3s ease'}
                _hover={{
                    bg: useColorModeValue('blackAlpha.300', 'whiteAlpha.300'),
                }}>
                <VisuallyHidden>{label}</VisuallyHidden>
                {children}
            </IconButton>
        </Tooltip>
    );
};

// bezier path and copyright with social buttons
const Footer = ({ loggedIn }: { loggedIn: boolean }) => {
    const { t } = useI18n();
    const year = new Date().getFullYear();
    return (
        <Box>
            {/* <svg viewBox="0 125 1440 105">
                <path fill='lightgray' fillOpacity=".5" d="M 2 166 L 67 186 C 121 206 192 224 288 224 C 384 224 484 202 634 177 C 761 159 781 152 935 188 C 1017 213 1055 221 1189 223 C 1292 212 1341 192 1434 166 L 1435 235 L 3 237 Z"></path>
            </svg> */}
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100px" viewBox="0 0 1200 100" preserveAspectRatio="none">
                <defs>
                    <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#fff" stopOpacity="1" />
                        <stop offset="100%" stopColor="#ddd" stopOpacity="1" />
                    </linearGradient>
                    <linearGradient id="grad2" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#7bd142" stopOpacity="1" />
                        <stop offset="100%" stopColor="#5cae2e" stopOpacity="1" />
                    </linearGradient>
                </defs>

                {/* <!-- Background gradient --> */}
                <rect width="1200" height="100" fill="url(#grad1)" />

                {/* <!-- Green wave --> */}
                <path d="M0,50 C300,100 900,0 1200,50 L1200,100 L0,100 Z" fill="url(#grad2)" />

                {/* <!-- White overlay wave --> */}
                <path d="M0,60 C300,110 900,10 1200,60 L1200,100 L0,100 Z" fill="#ffffff" opacity="0.5" />
            </svg>

            <Separator orientation='horizontal' background='lightgray' colorScheme='gray' />

            <Box bg={useColorModeValue('gray.100', 'gray.600')} px='1rem' py='.5rem' boxShadow='lg'>
                <Flex
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    width='100%'
                >
                    <Flex gap='.5rem'>
                        <Text>© 2023-{year}</Text>
                        <Tooltip content={t('footer.country')}>
                            <CountryFlag code='CH' />
                        </Tooltip>
                    </Flex>

                    <Flex gap='1rem'>
                        <SocialButton label={t('footer.contact')} href={'/contact'}>
                            <FcFeedback />
                        </SocialButton>
                        <SocialButton label={t('footer.info')} href={'/info'}>
                            <FcInfo />
                        </SocialButton>
                        {loggedIn && (
                            <SocialButton label={t('footer.development')} href={'/dev'}>
                                <FcInspection />
                            </SocialButton>
                        )}

                    </Flex>
                </Flex>
            </Box>
        </Box>
    );
}

export default Footer
